import React, { Fragment } from 'react';

import TEXT from '../../../../../data/text.json';

import FormController from '../../form-components/form-controller';
import OverlayWrapper from '../../form-components/overlay-wrapper';
import FormWrapper from '../../form-components/form-wrapper';
import TextArea from '../../form-components/text-area';
import EmailInput from '../../form-components/email-input';
import ErrorMessage from '../../form-components/error-message';

export default class GeneralForm extends FormController {
  constructor(props) {
    super(
      props,
      ['itemIdValue', 'infoValue', 'emailValue'],
      ['infoValue', 'emailValue'],
      2
    );
  }

  componentWillMount() {
    if (this.props.itemId && !this.props.recoveryState) {
      this.setItemIdValue({ target: { value: this.props.itemId } });
    }
  }

  render() {
    const { closeForm, secondaryButtonIsBack, clearForm } = this.props;
    return (
      <OverlayWrapper
        title={TEXT.CONTRIBUTION_FORMS.GENERAL_INFORMATION.title}
        subTitle={TEXT.CONTRIBUTION_FORMS.GENERAL_INFORMATION.subTitle}
        footerProps={this.getFooterProps()}
        stages={[
          {
            name: 'Details',
            active: this.state.stage === 1,
            onClick: () => this.setState({ stage: 1 })
          },
          {
            name: 'Finish',
            active: this.state.stage === 2,
            onClick: () => this.setState({ stage: 2 })
          }
        ]}
      >
        <FormWrapper>
          {this.state.stage === 1 && (
            <TextArea
              required
              id={TEXT.FORMS.infoId}
              label={TEXT.FORMS.infoLabel}
              placeholder={TEXT.FORMS.infoPlaceholder}
              value={this.state.infoValue}
              onChange={this.setInfoValue}
            />
          )}

          {this.state.stage === 2 && (
            <Fragment>
              <EmailInput
                emailValue={this.state.emailValue}
                setEmailValue={this.setEmailValue}
              />

              {!this.state.formValid && (
                <ErrorMessage
                  title="Form not complete for submission"
                  message={this.validationMessage(this.state)}
                />
              )}
            </Fragment>
          )}
        </FormWrapper>
      </OverlayWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/general-form/index.js